import React, { Component } from 'react';
import style from './style/reportswipeviewwrapper.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';


/** ReportSwipeViewWrapper component
 *
 * Creates a reusable wrapper for the SwipeView containing arrows to move back and forward through slides
 *
 * @example
 * <ReportSwipeViewWrapper
 *      handleNext={ functionToSwitchToNextSlide() }
 *      handleBack={ functionToSwitchToPrevSlide() }
 *      classes={ { optionalClasses } }
 * >
 *      <div>
 *          <SwipeViewContainer />
 *      </div>
 * </ReportSwipeViewWrapper>
 */
export default class ReportSwipeViewWrapper extends Component {
    render() {
        const { children, handleNext, handleBack, classes } = this.props;

        return <ul className={ `${style.reportSwipeViewWrapper} ${classes.root}` }>
            <li className={ style.swipeContentItemNavigation }>
                <div>
                    <FontAwesomeIcon
                        icon={ 'arrow-left' }
                        onClick={ () => {
                            handleBack();
                        }}
                    />
                </div>
            </li>
            <li className={ classes.swipeContent }>
                { children }
            </li>
            <li className={ style.swipeContentItemNavigation__right }>
                <div>
                    <FontAwesomeIcon
                        icon={ 'arrow-right' }
                        onClick={ () => {
                            handleNext();
                        }}
                    />
                </div>
            </li>
        </ul>;
    }
}

ReportSwipeViewWrapper.propTypes = {
    handleNext: PropTypes.func,
    handleBack: PropTypes.func,
    classes: PropTypes.shape({
        root: PropTypes.string,
        swipeContent: PropTypes.string
    })
};

ReportSwipeViewWrapper.defaultProps = {
    handleNext: null,
    handleBack: null,
    classes: {
        root: '',
        swipeContent: ''
    }
};
